import { Ownership } from '../../PerformancePortal/ContactListening/PastContactsTypes';
import { TimeOption } from '../../PerformancePortal/Dashboard/DashboardComponents/LighthouseMetrics/types';

export interface PastContact {
  COMM_ID: string;
  TIME: string;
  CHANNEL_NAME: string;
  CALL_DURATION_SECONDS?: number;
  SIC_NODE_1_NAME: string;
  OWNERSHIP_TYPE: Ownership;
  SAVED: boolean;
}

export interface GetContactsInput {
  userId: string;
  alias: string;
  timeOption: TimeOption;
  timestamp: string;
}

export interface GetContactsResponse {
  getContacts: {
    pastContacts: PastContact[];
    savedContacts: PastContact[];
  };
}

export enum SavedContactAction {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

export interface UpdateSavedContactInput {
  userId: string;
  contactId: string;
  dateAndTime: string;
  channel: string;
  duration: string;
  sic: string;
  ownershipType: string;
  action: SavedContactAction;
}

export interface UpdateSavedContactResponse {
  updateSavedContacts: {
    status: Boolean;
  };
}
